<template>
    <card class="spaced typo" v-if="loaded">
        
        <h2 class="text-white mb-4">
            {{ $t('xapi.privacy.my-endpoint') }}
        </h2>

        <form @submit.prevent="update" @keydown="errors.clear($event.target.name)">

            <p v-if="endpoint">
                {{ $t('xapi.privacy.my-endpoint-existing') }}
            </p>

            <div class="form-row" v-if="endpoint">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    URL
                </label>

                <div class="col-md-11 endpoint">
                    {{ endpoint }}
                </div>
            </div>

            <p v-else>
                {{ $t('xapi.privacy.my-endpoint-empty') }}
            </p>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('common.username') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.privacy.my-endpoint-username')"
                    required
                    v-model="username"
                    name="username"
                    :error="errors.get('username')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('common.password') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.privacy.my-endpoint-password')"
                    required
                    v-model="password"
                    name="password"
                    :error="errors.get('password')">
                </base-input>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="update" v-if="endpoint">
                    {{ $t('common.update') }}
                </base-button>

                <base-button type="primary" native-type="submit" @click="update" :loading="saving" v-else>
                    {{ $t('common.create') }}
                </base-button>
            </div>

            <div class="text-center text-danger pt-3" v-if="error">
                {{ error }}
            </div>

        </form>
    </card>
</template>

<script>
    import FormErrors from '@trax/classes/FormErrors';

    export default {

        data() {
            return {
                errors: new FormErrors(),
                error: null,
                loaded: false,
                saving: false,
                endpoint: null,
                username: null,
                password: null,
            }
        },

        created() {
            axios.get('/trax/api/front/privacy/endpoint').then(resp => {
                this.loaded = true
                this.setData(resp.data)
            })
        },

        methods: {

            update() {
                this.saving = true
                axios.post('/trax/api/front/privacy/endpoint', {
                    username: this.username,
                    password: this.password,
                }).then(resp => {
                    this.errors.clearAll()
                    this.error = null
                    this.setData(resp.data)
                    this.saving = false
                })
                .catch(err => {
                    this.saving = false
                    if (err.response.status == 404) {
                        this.error = this.$t('xapi.privacy.my-endpoint-token-error')
                    } else if (err.response.status == 422) {
                        this.errors.set(err.response.data.errors)
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })
            },

            setData(respData) {
                if (respData.endpoint) {
                    this.endpoint = respData.endpoint
                    this.username = respData.username
                    this.password = respData.password
                } else {
                    this.endpoint = null
                    this.username = null
                    this.password = null
                }
            }
        }
    }
</script>

<style scoped>
    .endpoint {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.75rem;
        font-size:0.75rem;
        padding-top:9px;
        padding-left:24px;
        padding-bottom:12px;
    }
</style>
